<template>
  <aha-modal @hide="hide()" :title="title_DeleteTeamFolder">
    <div :inner-html.prop="modalContent" />
    <div class="pl-4 mt-2 overflow-auto max-h-24" v-if="folder.presentations.length">
      <ul class="list-disc">
        <li
          v-for="(presn, presnIndex) in folder.presentations"
          :key="presnIndex"
        >
          {{ presn.name }}
        </li>
      </ul>
    </div>
    <template #action>
      <aha-button
        variant="danger"
        :disabled="isDeletingFolder"
        @click="handleDeleteTeamFolder()"
        icon-name="delete"
        :submitting="isDeletingFolder"
        has-margin-right
      >
        <aha-spinner variant="white" class="mr-1" v-if="isDeletingFolder" />
        {{ $i18nPresenter.t('Remove') }}
      </aha-button>
      <aha-link @click="hide()">
        <span class="font-bold">{{ $i18nPresenter.t('Cancel') }}</span>
      </aha-link>
    </template>
  </aha-modal>
</template>
<script>
import { mapState, mapActions } from 'vuex'

// api
import FolderApi from '@/api/folder'

// constants
import eventCategories from '@/constant/eventCategories'
import constants from '@/constant'

// utils
import utils from '@/util'

export default {
  props: {
    folder: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isDeletingFolder: false,
      modalContent: '',
      title_DeleteTeamFolder: this.$i18nPresenter.t('Remove confirmation'),
    }
  },
  computed: {
    ...mapState({
      folders: (state) => state.folders,
    }),
  },
  mounted() {
    this.generateModalContent()
  },
  methods: {
    ...mapActions([
      'setFoldersAction',
      'setErrorOnInternalServerAction',
    ]),
    generateModalContent() {
      const mainContent =
      `Are you sure you want to remove this folder
      <span class="font-bold break-words"> ${this.folder.folderName}</span>?
      `
      let moreContent = '<p>It contains no presentation.</p>'
      const numberOfPresn = this.folder.presentations.length
      if (numberOfPresn === 1) {
        moreContent = '<p>It contains 1 presentation:</p>'
      } else if (numberOfPresn > 1) {
        moreContent = `<p>It contains ${numberOfPresn} presentations:</p>`
      }
      this.modalContent = mainContent + moreContent
    },
    handlAfterCallAPIDeleteFolder() {
      utils.showToastSuccess(`${this.$i18nPresenter.t('Deleted folder')} "${this.folder.folderName}"`)
      utils.mixpanelTracking(constants.eventCategories.PRESENTATION_LIST, 'Folder Kebab Menu > Delete Team Folder > Succeeded', null, null, {
        isTeamFolder: this.$store.state.workingMode === constants.workspace.TEAM,
        isSelfCreatedTeam: this.$store.state.currentAccount.createdFrom === 'presenter',
        role: this.$store.state.currentUser.accountRole || null,
        teamId: this.$store.state.currentAccount.id || null,
        folderId: this.folder.folderId,
      })
      const index = this.folders.findIndex((folder) => {
        return folder.folderId === this.folder.folderId
      })
      this.folders.splice(index, 1)
      this.setFoldersAction(this.folders)
    },
    async handleDeleteTeamFolder() {
      this.isDeletingFolder = true
      utils.mixpanelTracking(eventCategories.PRESENTATION_LIST, 'Folder Kebab Menu > Delete Team Folder > Submit')
      try {
        await FolderApi.removeTeamFolderById(
          this.$store.state.currentAccount.id,
          this.folder.folderId,
          {},
        )
        this.handlAfterCallAPIDeleteFolder()
      } catch {
        utils.mixpanelTracking(eventCategories.PRESENTATION_LIST, 'Folder Kebab Menu > Delete Team Folder > Failed')
        this.setErrorOnInternalServerAction(`Cannot delete folder ${this.folder.folderName}`)
      } finally {
        this.isDeletingFolder = false
        this.hide()
      }
    },
    hide() {
      this.$emit('hide')
    },
  },
}
</script>
